module.exports = __webpack_public_path__ + "img/ongoing_map.9d7e9138.png";